// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const signinPolicySchema = z.object({
  "pureid_qr_channel_enabled": z.boolean(),
  "webauthn_hybrid_disabled": z.boolean(),
  "number_matching": z.enum(["disabled", "user_choice", "always"]),
  "match_number_length": z.number().int().min(2).max(4),
  "push_login_enabled": z.boolean(),
  "push_login_device_scope": z.enum(["same_device_only", "cross_device_allowed", "both"]),
  "updated_at": z.string().datetime({ offset: true }).optional()
});
